import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import ReviewModal from "./review-modal";
import ReplyModal from "./reply-modal";
import Edit from "../review/edit";
import Delete from "../review/delete";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchFeedbackByTourId,
  fetchFeedbackCountByTour,
} from "@/redux/slices/feedbackSlice";
import { formatCreatedDate } from "@/Helpers/BaseHelper";
const Reviews = ({ tourId }) => {
  const { user } = useSelector((state) => state.auth);

  var userId = 0;
  if (user) {
    const decoded = jwtDecode(user);
    userId = decoded["sub"];
  } else {
    userId = 0;
  }

  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showReplyModal, setShowReplyModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [feedbackEdit, setFeedbackEdit] = useState({});
  const [feedbackId, setFeedbackId] = useState(0);

  const [parentFeedbackId, setParentFeedbackId] = useState(0);

  const [showAllFeedbacks, setShowAllFeedbacks] = useState(false);

  const {
    feedbacks,
    feedbackCount,
    loading,
    averageRating,
    ratingStats,
    ratingPercentages,
  } = useSelector((state) => state.feedback);

  const ratings = [5, 4, 3, 2, 1];
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchFeedbackByTourId(tourId));
    dispatch(fetchFeedbackCountByTour(tourId));
  }, [dispatch, tourId]);

  const handleCreateFeedback = () => {
    setShowReviewModal(true);
  };

  const handleReplyFeedback = (feedbackId) => {
    setParentFeedbackId(feedbackId); // Cập nhật state
    setShowReplyModal(true);
  };

  const handleEditFeedback = (feedbackId, comment, rating) => {
    setFeedbackEdit({
      feedbackId: feedbackId,
      comments: comment,
      rating: rating,
    });
    setShowEditModal(true);
  };
  //handle change (parent)feedbackId
  useEffect(() => {}, [parentFeedbackId, feedbackEdit, feedbackId]);
  return (
    <>
      <div
        className="d-flex align-items-center justify-content-between flex-wrap mb-2"
        id="reviews"
      >
        <h6 className="mb-3">Đánh giá ({feedbackCount})</h6>

        <a
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#add_review"
          className="btn btn-primary btn-md mb-3"
          onClick={(e) => {
            e.preventDefault();
            handleCreateFeedback();
          }}
        >
          <i className="isax isax-edit-2 me-1"></i>Viết đánh giá
        </a>
      </div>
      <div className="row">
        <div className="col-md-6 d-flex">
          <div className="rating-item bg-light-200 text-center flex-fill mb-3">
            <h6 className="fw-medium mb-3">
              Đánh giá & Xếp hạng của Khách hàng
            </h6>
            <h5 className="display-6">{averageRating} / 5.0</h5>
            <div className="d-inline-flex align-items-center justify-content-center mb-3">
              <i className="ti ti-star-filled text-primary me-1"></i>
              <i className="ti ti-star-filled text-primary me-1"></i>
              <i className="ti ti-star-filled text-primary me-1"></i>
              <i className="ti ti-star-filled text-primary me-1"></i>
              <i className="ti ti-star-filled text-primary"></i>
            </div>
            <p>Dựa trên {feedbacks.length} Đánh giá</p>
          </div>
        </div>
        <div className="col-md-6 d-flex">
          <div className="card rating-progress shadow-none flex-fill mb-3">
            <div className="card-body">
              {ratings.map((star, index) => (
                <div className="d-flex align-items-center mb-2" key={index}>
                  <p className="me-2 text-nowrap mb-0">Xếp hạng {star} sao</p>
                  <div
                    className="progress w-100"
                    role="progressbar"
                    aria-valuenow="90"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <div
                      className="progress-bar bg-primary"
                      style={{ width: `${ratingPercentages[star]}%` }}
                    ></div>
                  </div>
                  <p className="progress-count ms-2">{ratingStats[star]}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {loading && <p>Loading...</p>}
      {feedbacks && feedbacks.length > 0 ? (
        feedbacks
          .slice(0, showAllFeedbacks ? feedbacks.length : 2)
          .map((feedback) => (
            <div
              className="card review-item shadow-none mb-3"
              key={feedback.feedbackId}
            >
              <div className="card-body p-3">
                <div className="review-info">
                  <div className="d-flex align-items-start justify-content-between flex-wrap">
                    <div className="d-flex align-items-center mb-2">
                      <span className="avatar avatar-lg me-2 flex-shrink-0">
                        {console.log(feedback.user, "userInfo")}
                        <img
                          src={
                            feedback.user && feedback.user.imageUrl
                              ? feedback.user.imageUrl
                              : ""
                          }
                          className="rounded-circle"
                          alt="Img"
                        />
                      </span>
                      <div>
                        <h6 className="fs-16 fw-medium mb-1">
                          {feedback.user.fullName}
                        </h6>
                        <div className="d-flex align-items-center flex-wrap date-info">
                          <p className="fs-14 mb-0">
                            {formatCreatedDate(feedback.createdDate)}
                          </p>
                          <p className="fs-14 d-inline-flex align-items-center mb-0">
                            <span className="badge badge-warning badge-xs text-gray-9 fs-13 fw-medium me-2">
                              {feedback.rating}.0
                            </span>
                            Convenient Location!
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex align-items-center">
                      {+userId === +feedback.userId && (
                        <>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleEditFeedback(
                                feedback.feedbackId,
                                feedback.comments,
                                feedback.rating
                              );
                            }}
                            className="btn btn-white btn-sm border me-md-1"
                          >
                            <i className="isax isax-edit-2 me-1"></i>Edit
                          </a>
                          <a
                            href="#"
                            className="btn btn-white btn-sm border me-md-1"
                            onClick={(e) => {
                              e.preventDefault();
                              setFeedbackId(feedback.feedbackId);
                              setShowDeleteModal(true);
                            }}
                          >
                            <i className="isax isax-trash me-1"></i>Delete
                          </a>
                        </>
                      )}

                      <a
                        href="#"
                        className="btn btn-white btn-sm border me-md-1"
                        onClick={(e) => {
                          e.preventDefault();

                          handleReplyFeedback(feedback.feedbackId);
                        }}
                      >
                        <i className="isax isax-repeat me-1"></i>Reply
                      </a>
                    </div>
                  </div>
                  <p className="mb-2 me-2">{feedback.comments}</p>
                  {/* <div className="d-inline-flex align-items-center">
                    <a
                      href="#"
                      className="d-inline-flex align-items-center fs-14 me-3"
                    >
                      <i className="isax isax-like-1 me-2"></i>13
                    </a>
                    <a
                      href="#"
                      className="d-inline-flex align-items-center me-3"
                    >
                      <i className="isax isax-dislike me-2"></i>38
                    </a>
                    <a
                      href="#"
                      className="d-inline-flex align-items-center me-3"
                    >
                      <i className="isax isax-heart5 text-danger me-2"></i>75
                    </a>
                  </div> */}
                </div>
                {feedback.replies.length > 0 &&
                  feedback.replies.map((reply) => (
                    <div
                      className="review-info reply mt-4 p-3"
                      key={reply.feedbackId}
                    >
                      <div className="d-flex align-items-start justify-content-between flex-wrap">
                        <div className="d-flex align-items-center mb-2">
                          <span className="avatar avatar-lg me-2 flex-shrink-0">
                            <img
                              src={reply.user.imageUrl}
                              className="rounded-circle"
                              alt="Img"
                            />
                          </span>
                          <div>
                            <h6 className="fs-16 fw-medium mb-1">
                              {reply.user.fullName || "Loading..."}
                            </h6>
                            <div className="d-flex align-items-center flex-wrap date-info">
                              <p className="fs-14 mb-0">
                                {formatCreatedDate(reply.createdDate)}
                              </p>
                              <p className="fs-14 d-inline-flex align-items-center mb-0"></p>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          {+userId === +reply.userId && (
                            <>
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEditFeedback(
                                    reply.feedbackId,
                                    reply.comments,
                                    0
                                  );
                                }}
                                className="btn btn-white btn-sm border me-md-1"
                                data-bs-toggle="modal"
                                data-bs-target="#edit_review"
                              >
                                <i className="isax isax-edit-2 me-1"></i>Edit
                              </a>
                              <a
                                href="#"
                                className="btn btn-white btn-sm border me-md-1"
                                data-bs-toggle="modal"
                                data-bs-target="#delete_modal"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setFeedbackId(reply.feedbackId);
                                  setShowDeleteModal(true);
                                }}
                              >
                                <i className="isax isax-trash me-1"></i>Delete
                              </a>
                            </>
                          )}
                        </div>
                      </div>
                      <p className="mb-2 me-2">{reply.comments}</p>
                      {/* <div className="d-inline-flex align-items-center">
                        <a
                          href="#"
                          className="d-inline-flex align-items-center fs-14 me-3"
                        >
                          <i className="isax isax-like-1 me-2"></i>10
                        </a>
                        <a
                          href="#"
                          className="d-inline-flex align-items-center me-3"
                        >
                          <i className="isax isax-dislike me-2"></i>21
                        </a>
                        <a
                          href="#"
                          className="d-inline-flex align-items-center me-3"
                        >
                          <i className="isax isax-heart5 text-danger me-2"></i>
                          46
                        </a>
                      </div> */}
                    </div>
                  ))}
              </div>
            </div>
          ))
      ) : (
        <p>Chưa có phản hồi nào.</p>
      )}
      {feedbacks.length > 2 ? (
        <div className="text-center mb-4 mb-xl-0">
          <a
            href="#"
            className="btn btn-primary btn-md d-inline-flex align-items-center justify-content-center mt-2"
            onClick={(e) => {
              e.preventDefault();
              setShowAllFeedbacks(!showAllFeedbacks);
            }}
          >
            {showAllFeedbacks
              ? "See less reviews"
              : `See all ${feedbackCount} reviews`}
            <i className="isax isax-arrow-right-3 ms-1"></i>
          </a>
        </div>
      ) : (
        ""
      )}

      {user ? (
        <div>
          <ReviewModal
            showModal={showReviewModal}
            setShowModal={setShowReviewModal}
            tourId={tourId}
            userId={userId}
          />
          <ReplyModal
            showModal={showReplyModal}
            setShowModal={setShowReplyModal}
            tourId={tourId}
            userId={userId}
            parentFeedbackId={parentFeedbackId}
          />
          <Edit
            showModal={showEditModal}
            setShowModal={setShowEditModal}
            feedbackEdit={feedbackEdit}
          />
          <Delete
            showModal={showDeleteModal}
            setShowModal={setShowDeleteModal}
            feedbackId={feedbackId}
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Reviews;
